import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CompanyNameCombineModel from '../models/CompanyNameCombineModel';

interface CompanyNameCombineInputState {
    companyNameCombineInput: CompanyNameCombineModel,
    selectedCompanyNameCombineId: string,
    companyNameCombineInputExpand: boolean,
    triggerSave: number,
    companyNames: string[],
    triggerRefreshCompanyNames: number
}

const initialState: CompanyNameCombineInputState = {
    companyNameCombineInput: {
        id: "",
        name: "",
        companyNames: "",
    } as unknown as CompanyNameCombineModel,
    selectedCompanyNameCombineId: "",
    companyNameCombineInputExpand: true,
    triggerSave: 0,
    companyNames: [],
    triggerRefreshCompanyNames: 0
}

export const CompanyNameCombineInputSlice = createSlice({
    name: "CompanyNameCombineInput",
    initialState,
    reducers: {
        setCompanyNameCombineInputId: (state, action: PayloadAction<string>) => {
            state.companyNameCombineInput.id = action.payload;
        },
        setCompanyNameCombineInput: (state, action: PayloadAction<CompanyNameCombineModel>) => {
            state.companyNameCombineInput = action.payload;
        },
        setName: (state, action: PayloadAction<string>) => {
            state.companyNameCombineInput.name = action.payload;
        },
        setCompanyNames: (state, action: PayloadAction<string>) => {
            state.companyNameCombineInput.companyNames = action.payload;
        },
        setSelectedCompanyNameCombineId: (state, action: PayloadAction<string>) => {
            state.selectedCompanyNameCombineId = action.payload;
        },
        setCompanyNameCombineInputExpand: (state, action: PayloadAction<boolean>) => {
            state.companyNameCombineInputExpand = action.payload;
        },
        resetCompanyNameCombineInput: (state) => {
            state.companyNameCombineInput = initialState.companyNameCombineInput;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setDistinceCompanyNames: (state, action: PayloadAction<string[]>) => {
            state.companyNames = action.payload;
        },
        setTriggerRefreshCompanyNames: (state, action: PayloadAction<number>) => {
            state.triggerRefreshCompanyNames = action.payload;
        },
    }
});

export const CompanyNameCombineInputSelector = createSelector(
    (state: RootState) => state.companyNameCombineInput,
    (data) => data
);

export const {
    setCompanyNameCombineInputId,
    setCompanyNameCombineInput,
    setName,
    setCompanyNames,
    setSelectedCompanyNameCombineId,
    setCompanyNameCombineInputExpand,
    resetCompanyNameCombineInput,
    setTriggerSave,
    setDistinceCompanyNames,
    setTriggerRefreshCompanyNames
} = CompanyNameCombineInputSlice.actions;

export default CompanyNameCombineInputSlice.reducer;